let initialState = "";
const isfirsttime = (state = "", action) => {

    switch(action.type){ 
      case "SETISFIRSTTIME" : return action.parm;
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default isfirsttime